import React from "react";
import { Box, Container, Typography, Grid, Stack } from "@mui/material";
import { motion } from "framer-motion";
import Security from "@mui/icons-material/Security";
import Speed from "@mui/icons-material/Speed";
import IntegrationInstructions from "@mui/icons-material/IntegrationInstructions";
import AllInclusive from "@mui/icons-material/AllInclusive";

const MONO   = "'JetBrains Mono', 'Fira Code', ui-monospace, monospace";
const ACCENT = "#E2684A";
const PURPLE = "#7C3AED";
const BG     = "#030014";
const BG2    = "#0F0728";
const LINE   = "#1E2130";
const INK    = "#E7E9EE";
const INK2   = "#B6BBC6";
const INK3   = "#7D8390";
const R      = "14px";

const features = [
  { icon: <Security fontSize="large" />, title: "SOC 2 Ready",          desc: "Enterprise-grade security with full data encryption and GDPR compliance." },
  { icon: <Speed fontSize="large" />,    title: "<500ms Latency",        desc: "Real-time voice processing that feels indistinguishable from human conversation." },
  { icon: <IntegrationInstructions fontSize="large" />, title: "Seamless Integration", desc: "Connects with your existing CRM, Helpdesk, and internal databases via simple APIs." },
  { icon: <AllInclusive fontSize="large" />, title: "Omnichannel",       desc: "Deploy across Web, Phone (SIP/Twilio), SMS, and WhatsApp from a single platform." },
];

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 22 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.55, delay },
});

const ValueProp = () => (
  <Box sx={{ py: { xs: 10, md: 13 }, borderBottom: `1px solid ${LINE}`, background: BG }}>
    <Container maxWidth="lg">
      <Grid container spacing={5} alignItems="flex-start">
        {/* Left: text */}
        <Grid item xs={12} md={5}>
          <motion.div {...fadeUp(0)}>
            <Typography sx={{ fontFamily: MONO, fontSize: "12px", letterSpacing: "0.16em", textTransform: "uppercase", color: ACCENT, mb: 1.75 }}>
              Why Beanbag AI
            </Typography>
            <Typography sx={{
              fontFamily: "'IBM Plex Serif', serif",
              fontSize: { xs: "1.75rem", md: "2.25rem" },
              fontWeight: 600, letterSpacing: "-0.015em", lineHeight: 1.2,
              color: INK, mb: 2,
            }}>
              Engineering Excellence Built for Scale
            </Typography>
            <Typography sx={{ color: INK2, fontSize: "15px", lineHeight: 1.75, maxWidth: 480 }}>
              We don't rely on generic wrappers. Our infrastructure is built from the ground up to handle high-concurrency, mission-critical enterprise workloads with zero downtime.
            </Typography>
          </motion.div>
        </Grid>

        {/* Right: feature cards */}
        <Grid item xs={12} md={7}>
          <Grid container spacing={2}>
            {features.map((f, i) => (
              <Grid item xs={12} sm={6} key={i}>
                <motion.div {...fadeUp(i * 0.07)} style={{ height: "100%" }}>
                  <Box sx={{
                    p: "22px 24px", background: BG2,
                    border: `1px solid ${LINE}`, borderRadius: R, height: "100%",
                    transition: "border-color 0.2s, transform 0.2s",
                    "&:hover": { borderColor: `${ACCENT}60`, transform: "translateY(-2px)" },
                  }}>
                    <Box sx={{ color: ACCENT, mb: 1.5 }}>{f.icon}</Box>
                    <Typography sx={{ fontWeight: 600, color: INK, mb: 0.75, fontSize: "15.5px" }}>
                      {f.title}
                    </Typography>
                    <Typography sx={{ color: INK2, fontSize: "14px", lineHeight: 1.65 }}>
                      {f.desc}
                    </Typography>
                  </Box>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  </Box>
);

export default ValueProp;
